<script setup lang="ts">
import type { ComposedBody } from '@xcel-next/composer-schema'

type BreadcrumbItem = NonNullable<ComposedBody['mainStructurePath']>[number]

const props = defineProps<{
  pageType?: string
  breadcrumb: BreadcrumbItem[]
}>()

const prepareBreadcrumb = (): BreadcrumbItem[] => {
  let preparedBreadcrumb = [...props.breadcrumb]

  if (preparedBreadcrumb.length === 1 && preparedBreadcrumb[0].url === '/') {
    preparedBreadcrumb = []
  } else {
    if (props.pageType === 'structureterm') {
      preparedBreadcrumb[(preparedBreadcrumb.length - 1)].url = undefined
    }
  }
  return preparedBreadcrumb
}
</script>

<template>
  <ul class="bx-content bx-breadcrumb bx-typo--breadcrumb">
    <li v-for="(crumb, index) in prepareBreadcrumb()"
        :key="index"
        class="bx-breadcrumb__cell">
      <span v-if="index > 0"
            class="icon icon-arrow_breadcrumb">
        <svg><use href="#arrow_breadcrumb" /></svg>
      </span>
      <a v-if="crumb.url"
         :href="crumb.url"
         class="bx-breadcrumb__link">
        {{ crumb.name }}
      </a>
      <span v-else
            class="bx-breadcrumb__link">
        {{ crumb.name }}
      </span>
    </li>
  </ul>
</template>
